import React, { useMemo } from 'react';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';
import Form from 'components/ui/Form';
import TextBox from 'components/ui/TextBox';

import { isTemplate } from '../NoticeHelpers';

const FullWidthInput = styled(TextBox)`
  width: 100%;
`;

const NameInput = ({ values, errors, touched, setFieldValue }) => {
  const handleChange = (event) => {
    setFieldValue('name', event.target.value);
  };

  const disabled = useMemo(() => {
    return isTemplate(values);
  }, [values]);

  return (
    <Form.Item
      label={`${getTranslatedString('landlordPortal.noticeForm.title')} *`}
      validateStatus={touched.name && errors.name ? 'error' : null}
      help={touched.name && errors.name}
    >
      <FullWidthInput
        size="large"
        name="name"
        value={values.name}
        onChange={handleChange}
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default NameInput;
